import React, { Fragment, useContext, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import AppLayout from '../layouts/AppLayout'
import { AppContext } from '../contexts/AppContext'
import { Link } from 'react-router-dom'
import Spinner from 'react-activity/dist/Spinner'
import 'react-activity/dist/Spinner.css'
import { FiEdit, FiTrash2 } from 'react-icons/fi'
import { RiDeleteBinLine } from 'react-icons/ri'
import { TbSwitchHorizontal } from 'react-icons/tb'
import Tooltip from '../components/Tooltip'
import { RxCross2 } from 'react-icons/rx'
import { getTeamImage } from '../utils/team'
import { getCompetitionImage } from '../utils/competition'
import Swal from 'sweetalert2'

const AllCompetitions = () => {
  const { getCompetitions, deleteCompetition, userToken, isLoading } = useContext(AppContext)

  const [competitions, setCompetitions] = useState([])

  const fetchCompetitions = async () => {
    const response = await getCompetitions()
    setCompetitions(response)
  }

  const handleDelete = async (todelete) => {
    if (!isLoading) {
      try {
        const result = await Swal.fire({
          title: 'Are you sure to delete?',
          text: "You won't be able to undo this action",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Delete',
        })

        if (result.isConfirmed) {
          let response = await deleteCompetition(todelete)
          if (response === 'success') {
            fetchCompetitions()
          }
        }
      } catch (error) {
        Swal.fire('An Error Occurred', error, 'error')
      }
    }
  }

  useEffect(() => {
    fetchCompetitions()
  }, [])

  return (
    <AppLayout pageName='All Competitions'>
      {isLoading ? (
        <section>
          <div className='flex justify-center w-full py-12'>
            <Spinner
              color='#CCCCCC'
              size={24}
            />
          </div>
        </section>
      ) : (
        <section className='competitions'>
          <div className='flex sm:flex-row flex-col justify-between items-start mb-6'>
            <h1 className='text-2xl font-bold'>Competitions</h1>
            <Link to={'/competitions/create'}>
              <button className='btn-main'>Create Competition</button>
            </Link>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            {competitions.map((competition, index) => (
              <div
                key={index}
                className='relative'
              >
                <div className='p-4 hover:bg-neutral-50 border-2 rounded-lg border-neutral-100 cursor-pointer'>
                  <div className='flex space-x-2 text-base font-medium items-center text-neutral-800'>
                    {competition.logo && (
                      <img
                        width='30'
                        height='30'
                        src={getCompetitionImage(competition.logo)}
                        alt={competition.name}
                        className='rounded'
                      />
                    )}
                    <span>{competition.name}</span>
                  </div>
                </div>
                {userToken.type === 'Admin' && (
                  <div className='absolute right-0 top-0 h-full grid grid-rows-2'>
                    <Link to={`/competitions/${competition.id}`}>
                      <button className='flex-1 p-1 bg-white rounded-tr border'>
                        <Tooltip
                          text='edit'
                          customClass='!bg-blue-400 z-50'
                        >
                          <FiEdit className='text-blue-500 text-xs' />
                        </Tooltip>
                      </button>
                    </Link>
                    <button
                      onClick={() => handleDelete(competition.id)}
                      className='flex-1 p-1 bg-white rounded-br border'
                    >
                      <Tooltip
                        text='delete'
                        customClass='!bg-red-400 z-50'
                      >
                        <FiTrash2 className='text-red-500 text-xs' />
                      </Tooltip>
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      )}
    </AppLayout>
  )
}

export default AllCompetitions
